import { ElaborationMessage, ElaborationStatusItem } from "../redux/feature/object/remote-elaborations-slice";
import NotificationManager from "../common/notification/NotificationManager";
import { DB_LIST_NOTIFICATION } from "../utils/constants/notification";
import { formatMessage } from "../utils/helpers/LanguageHelper";

export async function handleDbMappingResult(item: ElaborationStatusItem) {
  if (item.status === "COMPLETED") {
    const isFullyCompleted = item.elabResult === "COMPLETED";
    const warnings: ElaborationMessage = {
      details: (item.messages ?? [])
        .map((message) => message?.details ?? message?.text)
        .filter((detail) => !!detail)
        .join(",\n"),
      severity: "WARNING",
      traceId: item.messages?.[0]?.traceId ?? "NOT DEFINED",
      text: formatMessage("cof.base.opendocument"),
    };

    NotificationManager.addNotification({
      key: DB_LIST_NOTIFICATION,
      title: isFullyCompleted
        ? formatMessage("cof.opendocuments.outline.dbmapping.title")
        : formatMessage("cof.opendocuments.outline.dbmapping.title.warning"),
      message: isFullyCompleted ? formatMessage("cof.opendocuments.outline.dbmapping.message") : null,
      type: isFullyCompleted ? "success" : "warning",
      closable: true,
      removeOnClose: true,
      isTemporary: isFullyCompleted,
      details: isFullyCompleted ? null : [warnings],
    });
    return;
  }

  // Error case
  NotificationManager.addNotification({
    key: DB_LIST_NOTIFICATION,
    message: formatMessage("cof.opendocuments.outline.dbmapping.message.error"),
    title: formatMessage("cof.opendocuments.outline.dbmapping.title.error"),
    type: "error",
    closable: true,
    removeOnClose: true,
    isTemporary: true,
  });
}
